import { ReactElement } from 'react';
import { Tooltip, Whisper } from 'rsuite';
import styles from '../styles.module.scss';

// Só os posicionamentos à direita: o tooltip nunca abre por cima dos cards vizinhos.
export type InfoTooltipPlacement = 'right' | 'rightStart' | 'rightEnd';

interface InfoTooltipProps {
  text: string;
  children: ReactElement;
  placement?: InfoTooltipPlacement;
  preventOverflow?: boolean;
}

// O elemento inteiro é o gatilho (sem ícone ⓘ). Com preventOverflow o tooltip desliza para dentro da tela em vez de ser cortado.
export const InfoTooltip = ({ text, children, placement = 'right', preventOverflow = true }: InfoTooltipProps) => (
  <Whisper placement={placement} preventOverflow={preventOverflow} trigger="hover" speaker={<Tooltip className={styles['info-tooltip']}>{text}</Tooltip>}>
    {children}
  </Whisper>
);
